import React from 'react';
import { Pagination } from '../../../_lib/components/Pagination';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ResultListSettings from '../../../components/molecules/ResultListSettings/ResultListSettings';
import {
  Table,
  TableBody,
  TableCell,
  TableCellDescription,
  TableCellPageLink,
  TableHead,
  TableModifier,
  TableRow,
} from '../../../components/organisms/Table';
import { murmurhash } from '../../../lib/js/hash';
import { DateRanger } from '../../../components/molecules/DateRanger/DateRanger';
import { FACETS } from '../../../components/molecules/ResultListSettings/ResultListSettings.enums';
import { Event, EventListSearchResults } from '../EventListDetails.types';

type EventListTableProps = {
  searchResults: EventListSearchResults;
};

export function EventListTable({ searchResults }: EventListTableProps) {
  const { t } = useSonTranslation('EventList');
  const titleLabel = t('titleLabel');
  const shortDescriptionLabel = t('shortDescriptionLabel');
  const eventDateLabel = t('eventDateLabel');
  const { eventStartDate: filter, ...facetsWithoutEventStartDate } = searchResults.facets ?? {};

  return (
    <div className="event-list">
      <ResultListSettings
        key={murmurhash(searchResults)}
        sort={searchResults.sort}
        facets={facetsWithoutEventStartDate}
        filter={filter}
        wantedFacets={[FACETS.FQ_PAGE_CATEGORY_TITLES]}
        resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
      />
      {searchResults.events && searchResults.events.length > 0 && (
        <>
          <Table caption={t('caption')}>
            <TableHead>
              <TableRow>
                <TableCell modifier={TableModifier.XLWIDTH}>{titleLabel}</TableCell>
                <TableCell>{shortDescriptionLabel}</TableCell>
                <TableCell modifier={TableModifier.MWIDTH}>{eventDateLabel}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchResults.events.map((resultItem: Event) => {
                return (
                  <TableRow key={murmurhash(resultItem)}>
                    <TableCellPageLink
                      label={titleLabel}
                      pageLink={resultItem.pageLink}
                      pagePackState={resultItem.packState}
                      categories={resultItem.categories}
                      integrated={resultItem.integrated}
                    />
                    <TableCellDescription label={shortDescriptionLabel} description={resultItem.teaserText} />
                    <TableCell dataHead={eventDateLabel}>
                      <DateRanger
                        start={resultItem.eventStartDate}
                        end={resultItem.eventEndDate}
                        multiDayEvent={resultItem.multiDayEvent}
                        allDayEvent={resultItem.allDayEvent}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Pagination pageItems={searchResults.pageItems} />
        </>
      )}
    </div>
  );
}
